export default __webpack_public_path__ + "static/media/CX.d1447c43.svg";